import React, { useEffect, useState } from "react";
import { BrowserRouter, Route, Redirect } from "react-router-dom";

import ActivationCode from "../pages/ActivationCode";
import ForgotPassword from "../pages/ForgotPassword";
// import Home from "../pages/Home";
import Login from "../pages/Login";
import NewPassword from "../pages/NewPassword";
import Signup from "../pages/Signup";

const AuthRoutes: React.FC = () => {
  const [role, setRole] = useState("");

  useEffect(() => {
    setRole(window.location.pathname.split("/")[2]);
  }, []);

  return (
    <BrowserRouter>
      <Route exact path="/">
        <Redirect to="/login/entity" />
      </Route>
      <Route exact path="/login/entity" component={Login} />
      <Route exact path="/login/admin" component={Login} />
      <Route
        exact
        path={`/forgot-password/${role}`}
        component={ForgotPassword}
      />
      <Route
        exact
        path={`/activation-code/${role}`}
        component={ActivationCode}
      />
      <Route exact path={`/new-password/${role}`} component={NewPassword} />
      <Route exact path="/signup/entity" component={Signup} />
    </BrowserRouter>
  );
};

export default AuthRoutes;
